// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAKkzkQW1WgRf_XHfVjearRsOUL94MVAWI",
  authDomain: "lunadar-7c858.firebaseapp.com",
  databaseURL: "https://lunadar-7c858-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "lunadar-7c858",
  storageBucket: "lunadar-7c858.appspot.com",
  messagingSenderId: "1062728002181",
  appId: "1:1062728002181:web:8695c9371d9d28109957ec",
  measurementId: "G-VDTPSBHDWW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const database = getDatabase(app);

export {
  app,
  analytics,
  database
};
